import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_ORIGIN = "https://www.virtualpsych.com";

/**
 * Keeps <link rel="canonical"> in sync with the current route.
 *
 * - Strips trailing slashes (except for "/").
 * - Lowercases the path so /Foo and /foo can't be treated as separate URLs.
 * - Drops query strings and hashes from the canonical, which is the safe default
 *   for a content site with no parameter-driven content.
 *
 * Route components that need a more specific canonical (e.g. dynamic SEO pages)
 * can still override the tag in their own useEffect; this just guarantees every
 * route has one.
 */
const CanonicalUrl = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        let path = (pathname || "/").toLowerCase();
        if (path.length > 1 && path.endsWith("/")) {
            path = path.replace(/\/+$/, "");
        }

        const href = path === "/" ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${path}`;

        let link = document.head.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            document.head.appendChild(link);
        }
        link.setAttribute("href", href);
    }, [pathname]);

    return null;
};

export default CanonicalUrl;
